  <template>
  <!--SECTION INDUSTRIES-->
  <main>
    <div class="bank">
      <div class="container-db bread-container">
        <div class="bread-crumbs">
          <router-link to="/">Home</router-link>
          <span class="bread-separator">/</span>
          <span class="bread-current">Social Network for Dog Owners </span>
        </div>
      </div>
      <div class="container-db">
        <h1 class="bank-title">Dog Social Network for Pet Owners (Dogito)</h1>
      </div>
    </div>
    <div class="descrip-result-wrapper">
      <div class="descrip-result-text">
        <div class="container-db">
          <div class="decription-container">
            <div class="description portfolio-container">
              <div class="portfolio-container-top">
                <div>
                  <h2>Project Overview</h2>
                  <p>
                    Dogito is an innovative dog social network that connects dog owners and their pets in a unique digital community. Combining the best features of traditional social platforms with exclusive tools for pet lovers, Dogito is the ultimate social network for dogs.
                  </p>
                  <p>
                    The platform is available as a web version and a mobile app for iOS and Android, ensuring that dog owners stay connected wherever they go.
                  </p>

                  <div class="tech-features-section">
                    <div class="container-db bank-tech">
                      <div class="tech-features-wrapper">
                        <div class="features">
                          <h2 class="tech-features-title">With Dogito, users can:</h2>
                          <ul>
                            <li class="marked-item">
                              Create personalized pet profiles for themselves and their dogs.
                            </li>
                            <li class="marked-item">
                              Share engaging content — photos, videos, blogs, and pet care tips.
                            </li>
                            <li class="marked-item">
                              Find new friends and join themed pet social network groups.
                            </li>
                            <li class="marked-item">
                              Use an interactive dog-friendly map to discover pet-friendly locations.
                            </li>
                            <li class="marked-item">
                              Arrange dog meetups and group walks with local pet owners.
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <img
                  class="dogito-img"
                  v-lazyload
                  data-url="/img/images-db/case-studies/Dogito.webp"
                  alt="Custom web development"
                  title="Custom web development"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container-db container-info">
      Dogito offers social media login (Facebook, Google) and email registration. The platform supports multiple languages, including English, German, and Spanish, making it an inclusive social network for pets worldwide.
    </div>

    <div class="container-db container-mark container-key">
      <h2>Key Features of the Best Dog Social Media App</h2>
      <p>Personalized Dog & Owner Profiles</p>
      <ul class="features">
        <li class="marked-item">
          Create unique profiles for your dog and yourself.
        </li>
        <li class="marked-item">
          Add photo albums, videos, and personal pet blogs.
        </li>
        <li class="marked-item">
          Get tailored recommendations based on your interests.
        </li>
      </ul>
      <p>Find Trainers & Veterinarians Easily</p>
      <ul class="features">
        <li class="marked-item">
          Search for certified dog trainers and get in your area.
        </li>
        <li class="marked-item">
          Read reviews, ratings, and service details before booking.
        </li>
        <li class="marked-item">
          Schedule appointments online, directly through the platform.
        </li>
      </ul>
      <p>Organize Dog Walks & Meetups</p>
      <ul class="features">
        <li class="marked-item">
          Invite fellow dog lovers for group walks and playdates.
        </li>
        <li class="marked-item">
          Join dog-friendly events in your neighborhood.
        </li>
        <li class="marked-item">
          Use location services to find dog owners nearby.
        </li>
      </ul>
      <p>Interactive Dog-Friendly Map</p>
      <ul class="features">
        <li class="marked-item">
          Discover pet-friendly cafés, parks, pet hotels, and veterinary clinics.
        </li>
        <li class="marked-item">
          Seamless integration with Google Maps and OpenStreetMap.
        </li>
        <li class="marked-item">
          Users can add new dog-friendly locations and leave reviews.
        </li>
      </ul>
      <p>Built-in Chat for Dog Owners</p>
      <ul class="features">
        <li class="marked-item">
          Enjoy real-time conversations in personal or group chats.
        </li>
        <li class="marked-item">
          Create exclusive communities for dog clubs or pet enthusiasts.
        </li>
        <li class="marked-item">
          Share dog photos, videos, and event updates instantly.
        </li>
      </ul>
      <p>News Feed & Pet Owner Communities</p>
      <ul class="features">
        <li class="marked-item">
          Stay informed with a dedicated social network for pets.
        </li>
        <li class="marked-item">
          Follow topics on dog health, training, and nutrition.
        </li>
        <li class="marked-item">
          Interact with experts, share experiences, and vote in polls.
        </li>
      </ul>
      <p>Exclusive Premium Subscription</p>
      <ul class="features">
        <li class="marked-item">
          Access advanced features, including personalized pet recommendations, exclusive pet events, and extended chat functionalities.
        </li>
        <li class="marked-item">
          Enjoy priority access to professional dog trainers and veterinarians.
        </li>
      </ul>
    </div>
    <div class="container-db container-info">
      <h2>Who is Dogito For?</h2>
      <p>Dogito is the perfect social network for pets and their owners!</p>
      <ul class="features">
        <li class="marked-item">
          Dog Owners – Share experiences, connect with fellow pet lovers, and plan activities.
        </li>
        <li class="marked-item">
          Dog Trainers & Veterinarians – Offer services and gain new clients.
        </li>
        <li class="marked-item">
          Pet Businesses (dog-friendly cafés, pet shops, hotels) – Promote services to a growing pet community.
        </li>
      </ul>
    </div>
    <div class="container-db container-info">
      <h2>Why is Dogito the Best Social Media for Dogs?</h2>
      <p>Unlike other social platforms, Dogito is a dedicated social media for dogs, designed exclusively for dog owners and pet enthusiasts.</p>
      <ul class="features">
        <li class="marked-item">
          Dog-focused content – No distractions, just pet-related topics.
        </li>
        <li class="marked-item">
          Connect with local dog owners – Find new friends for your furry companion.
        </li>
        <li class="marked-item">
          Easily locate pet services – Search for dog trainers, vets, and pet-friendly locations.
        </li>
        <li class="marked-item">
          Interactive pet social network – Stay informed, engaged, and connected.
        </li>
      </ul>
      <p>Dogito is more than just a social network for dogs—it's a thriving pet social network, bringing dog lovers together to share, learn, and create memorable experiences.</p>
    </div>
    <div class="container-db container-info">
      <h2>Technologies Behind the Dogito Dog Social Network</h2>
      <p>Dogito is powered by modern <router-link to="/">web and mobile technologies</router-link>, ensuring a seamless and fast user experience:</p>
      <ul class="features">
        <li class="marked-item">
          Frontend: TypeScript, ReactJS, Redux, React Native
        </li>
        <li class="marked-item">
          Backend: Node.js, MySQL, Laravel, WebSockets
        </li>
      </ul>
    </div>
    <div class="relevant-case-studies">
      <div class="container-db">
        <h2>portfolio</h2>
        <div class="slider-container">
          <div class="relevant-case-studies-slider">
            <slick ref="slick" :options="slickOptions">
              <div class="case-slider-item">
                <router-link to="real-estate-platform">
                  <div class="case-studies-item">
                    <h3>Real Estate</h3>
                  </div>
                </router-link>
              </div>
              <div class="case-slider-item">
                <router-link to="art-galleries-development">
                  <div class="case-studies-item">
                    <h3>ArtGallery</h3>
                  </div>
                </router-link>
              </div>
              <div class="case-slider-item">
                <router-link to="banking-app">
                  <div class="case-studies-item">
                    <h3>Banking Application</h3>
                  </div>
                </router-link>
              </div>
              <div class="case-slider-item">
                <router-link to="currency-markets-exchange">
                  <div class="case-studies-item">
                    <h3>Markets and Exchanges</h3>
                  </div>
                </router-link>
              </div>
              <div class="case-slider-item">
                <router-link to="flexiswap-nft-swap-platform">
                  <div class="case-studies-item">
                    <h3>NFT Market and Swapping</h3>
                  </div>
                </router-link>
              </div>
              <div class="case-slider-item">
                <router-link to="currency-research-analasis-news-platform">
                  <div class="case-studies-item">
                    <h3>Currency Analysis and News</h3>
                  </div>
                </router-link>
              </div>
              <div class="case-slider-item">
                <router-link to="cannabis-platform">
                  <div class="case-studies-item">
                    <h3>Cannabis Platform</h3>
                  </div>
                </router-link>
              </div>
              <div class="case-slider-item">
                <router-link to="doctormed">
                  <div class="case-studies-item">
                    <h3>DoctorMed</h3>
                  </div>
                </router-link>
              </div>
            </slick>
          </div>
        </div>
      </div>
    </div>
    <AcquaintedSection />
    <div
      v-lazyload
      data-src="/img/images-db/parallax/stone2.webp"
      class="lazy-bg bottom-stone"
    ></div>
    <script v-html="jsonld" type="application/ld+json"></script>
  </main>
</template>
<script>
import Slick from "vue-slick";
import AcquaintedSection from "../AcquaintedSection";
let vm = {};
export default {
  name: "SocialNetworkForDogOwners",
  metaInfo: {
    title: "Dogito - The best social network for dogs and their owners",
    meta: [
      {
        vmid: "description",
        name: "description",
        content:
          "Join Dogito, an innovative social network for dogs and their owners! Create profiles, share photos and videos, search for veterinarians, organize appointments, and discover dog locations. Available on iOS, Android, and web.",
      },
      {
        vmid: "og:image:type",
        name: "og:image:type",
        content: "image/webp",
      },
      {
        vmid: "og:title",
        name: "og:title",
        content:
          "Dogito - The best social network for dogs and their owners",
      },
      {
        vmid: "og:description",
        name: "og:description",
        content:
          "Join Dogito, an innovative social network for dogs and their owners! Create profiles, share photos and videos, search for veterinarians, organize appointments, and discover dog locations. Available on iOS, Android, and web.",
      },
      // {
      //   vmid: "og:image",
      //   name: "og:image",
      //   content:
      //     "https://devbrother.com/img/images-db/case-studies/art-solutions.webp",
      // },
      {
        vmid: "og:type",
        name: "og:type",
        content: "website",
      },
      {
        vmid: "og:url",
        name: "og:url",
        content: "https://devbrother.com/cases/art-galleries",
      },
      {
        vmid: "twitter:title",
        name: "twitter:title",
        content:
          "Dogito - The best social network for dogs and their owners",
      },
      {
        vmid: "twitter:description",
        name: "twitter:description",
        content:
          "Join Dogito, an innovative social network for dogs and their owners! Create profiles, share photos and videos, search for veterinarians, organize appointments, and discover dog locations. Available on iOS, Android, and web.",
      },
      // {
      //   vmid: "twitter:image",
      //   name: "twitter:image",
      //   content:
      //     "https://devbrother.com/img/images-db/case-studies/art-solutions.webp",
      // },
    ],
  },
  components: { Slick, AcquaintedSection },
  mounted() {
			this.addCanonicalLink();
  },
	methods: {
			addCanonicalLink: () => {
				const link = document.createElement('link');
				link.setAttribute('rel', 'canonical');
				link.setAttribute('href', 'https://devbrother.com/cases/social-network-for-dog-owners');

				const oldLink = document.querySelector('link[rel="canonical"]');
				if (oldLink) {
					document.head.removeChild(oldLink);
				}

				document.head.appendChild(link);
			},
	},
  data() {
    const jsonld = {
      "@context": "https://schema.org",
      "@type": "IndividualProduct",
      name: "Dogito",
      description: "Social network",
    };
    return {
      jsonld,
      slickOptions: {
        prevArrow:
          '<div class="prev-arrow"><img src="/img/images-db/Arrow.svg" alt="arrow" class="arrow" width="26" height="11"/><img src="/img/images-db/Arrow-hover.svg" alt="arrow" class="arrow-hover" width="26" height="11"/></div>',
        nextArrow:
          '<div class="next-arrow"><img src="/img/images-db/Arrow.svg" alt="arrow" class="arrow" width="26" height="11"/><img src="/img/images-db/Arrow-hover.svg" alt="arrow" class="arrow-hover" width="26" height="11"/></div>',
        slidesToShow: 4,
        slidesToScroll: 1,
        // centerMode: true,
        responsive: [
          {
            breakpoint: 769,
            settings: {
              slidesToShow: 1,
              centerMode: false,
              prevArrow: "",
              nextArrow: "",
              dots: true,
              customPaging: function (slider, i) {
                return '<div class="slick-mobile-dot"></div>';
              },
            },
          },
        ],
        // Any other options that can be got from plugin documentation
      },
    };
  },
};
</script>
<style scoped lang="scss">

.container-key {
  p {
    font-weight: bold;
    margin-bottom: 10px;
    margin-top: 30px;
  }
}

.container-db {
  p {
    margin-bottom: 10px;
  }
}

.container-info, .container-mark {
  line-height: 1.8;
  h2 {
    margin-top: 70px;
  }
}

.wrap {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 50px;
  font-family: "Roboto Condensed";
  font-size: 18px;
  letter-spacing: 0.41px;
  line-height: 28px;
  position: relative;

  .marked {
    color: #06c6ff;
  }

  .img-wrap {
    max-width: 350px;
  }

  ol {
    padding: 0;
    list-style-type: none;

    li {
      position: relative;
      margin-bottom: 15px;
      padding-left: 35px;

      ::before {
        content: "";
        position: absolute;
        width: 20px;
        height: 20px;
        top: 3px;
        left: 0;
        background: url(/img/images-db/services/check_circle_icon.svg) no-repeat;
        background-size: contain;
      }
    }
  }
}

@media (max-width: 900px) {
  .wrap {
    flex-direction: column-reverse;
  }

  ol {
    width: 100%;
  }

  .img-wrap {
    max-width: 400px;
    width: 100%;
    margin-bottom: 25px;
  }
}

.relevant-case-studies {
  margin-top: 100px;
}
</style>
